function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.808 18.52l1.616-2.123a.78.78 0 0 0 .151-.58l-.315-2.2a.8.8 0 0 0-.891-.68.773.773 0 0 0-.668.879l.267 1.879-1.694 2.226a.778.778 0 0 0-.093.78l1.723 3.99 1.186-1.205-1.282-2.966z",
  fill: "#D1DBF6"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.808 18.52l1.616-2.123a.78.78 0 0 0 .151-.58l-.315-2.2a.8.8 0 0 0-.891-.68.773.773 0 0 0-.668.879l.267 1.879-1.694 2.226a.778.778 0 0 0-.093.78l1.723 3.99 1.186-1.205-1.282-2.966z",
  fill: "url(#bug_svg__paint0_linear)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.439 21.646a.797.797 0 0 0-.735-.122l-2.481.838-1.528-.3a.776.776 0 0 0-.916.618.796.796 0 0 0 .635.92l1.733.34a.777.777 0 0 0 .402-.028l2.282-.767 2.648 2.016 1.103-1.122-3.143-2.393z",
  fill: "#D1DBF6"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.439 21.646a.797.797 0 0 0-.735-.122l-2.481.838-1.528-.3a.776.776 0 0 0-.916.618.796.796 0 0 0 .635.92l1.733.34a.777.777 0 0 0 .402-.028l2.282-.767 2.648 2.016 1.103-1.122-3.143-2.393z",
  fill: "url(#bug_svg__paint1_linear)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.392 27.524a.772.772 0 0 0-.649.302l-2.167 2.848-2.435.311a.773.773 0 0 0-.668.878.801.801 0 0 0 .892.68l2.757-.353a.773.773 0 0 0 .519-.3l2.119-2.784 2.027.076c.526-.588 1.062-1.108 1.61-1.51l-4.005-.148z",
  fill: "#D1DBF6"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.392 27.524a.772.772 0 0 0-.649.302l-2.167 2.848-2.435.311a.773.773 0 0 0-.668.878.801.801 0 0 0 .892.68l2.757-.353a.773.773 0 0 0 .519-.3l2.119-2.784 2.027.076c.526-.588 1.062-1.108 1.61-1.51l-4.005-.148z",
  fill: "url(#bug_svg__paint2_linear)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30.15 27.812c.28.04.558-.074.728-.297l1.695-2.227 1.882-.242a.773.773 0 0 0 .668-.877.801.801 0 0 0-.891-.679l-2.206.283a.78.78 0 0 0-.518.299l-1.616 2.123-3.198-.443-.847 1.463 4.303.597z",
  fill: "#D1DBF6"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30.15 27.812c.28.04.558-.074.728-.297l1.695-2.227 1.882-.242a.773.773 0 0 0 .668-.877.801.801 0 0 0-.891-.679l-2.206.283a.78.78 0 0 0-.518.299l-1.616 2.123-3.198-.443-.847 1.463 4.303.597z",
  fill: "url(#bug_svg__paint3_linear)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.76 32.225l-.133 2.403a.811.811 0 0 0 .081.395l.788 1.58a.794.794 0 0 0 1.056.367.775.775 0 0 0 .352-1.048l-.694-1.392.145-2.615a.792.792 0 0 0-.312-.675l-3.141-2.39-.788 1.361 2.646 2.014z",
  fill: "#D1DBF6"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.76 32.225l-.133 2.403a.811.811 0 0 0 .081.395l.788 1.58a.794.794 0 0 0 1.056.367.775.775 0 0 0 .352-1.048l-.694-1.392.145-2.615a.792.792 0 0 0-.312-.675l-3.141-2.39-.788 1.361 2.646 2.014z",
  fill: "url(#bug_svg__paint4_linear)"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.364 38.7l-2.119 2.784a.78.78 0 0 0-.15.58l.394 2.751c.03.216.146.398.308.52a.795.795 0 0 0 .583.158.773.773 0 0 0 .668-.878l-.347-2.429 2.167-2.847a.772.772 0 0 0 .12-.704l-1.21-3.822c-.242.635-.6 1.29-1.026 1.954l.612 1.933z",
  fill: "#D1DBF6"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.364 38.7l-2.119 2.784a.78.78 0 0 0-.15.58l.394 2.751c.03.216.146.398.308.52a.795.795 0 0 0 .583.158.773.773 0 0 0 .668-.878l-.347-2.429 2.167-2.847a.772.772 0 0 0 .12-.704l-1.21-3.822c-.242.635-.6 1.29-1.026 1.954l.612 1.933z",
  fill: "url(#bug_svg__paint5_linear)"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.203 22.612l-5.214 5.305c-1.444.04-3.025.898-4.7 3.098-2.87 3.772-4.922 9.982-2.835 11.57 2.089 1.59 7.527-2.042 10.397-5.813 1.675-2.2 2.083-3.953 1.735-5.355l3.725-6.44a9.495 9.495 0 0 1-1.68-1.017 9.487 9.487 0 0 1-1.428-1.348z",
  fill: "#D1DBF6"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.203 22.612l-5.214 5.305c-1.444.04-3.025.898-4.7 3.098-2.87 3.772-4.922 9.982-2.835 11.57 2.089 1.59 7.527-2.042 10.397-5.813 1.675-2.2 2.083-3.953 1.735-5.355l3.725-6.44a9.495 9.495 0 0 1-1.68-1.017 9.487 9.487 0 0 1-1.428-1.348z",
  fill: "url(#bug_svg__paint6_linear)"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M44.784 13.75c-.215-.015-4.839-.282-11.077 2.771.324-1.288.429-2.514.221-3.476l-1.476 1.94-2.52-1.919 1.477-1.94c-.983.056-2.137.484-3.29 1.14 1.28-6.827-.21-11.213-.281-11.416a.797.797 0 0 0-1.004-.492.774.774 0 0 0-.482.992c.017.05 1.639 4.893-.124 12.188-1 .783-1.913 1.676-2.598 2.576-2.349 3.086-1.142 5.015.946 6.604 2.088 1.59 4.267 2.238 6.616-.847.685-.9 1.305-2.018 1.792-3.188 6.561-3.641 11.661-3.37 11.715-3.366.434.028.805-.3.827-.73a.8.8 0 0 0-.742-.837z",
  fill: "#D1DBF6"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M44.784 13.75c-.215-.015-4.839-.282-11.077 2.771.324-1.288.429-2.514.221-3.476l-1.476 1.94-2.52-1.919 1.477-1.94c-.983.056-2.137.484-3.29 1.14 1.28-6.827-.21-11.213-.281-11.416a.797.797 0 0 0-1.004-.492.774.774 0 0 0-.482.992c.017.05 1.639 4.893-.124 12.188-1 .783-1.913 1.676-2.598 2.576-2.349 3.086-1.142 5.015.946 6.604 2.088 1.59 4.267 2.238 6.616-.847.685-.9 1.305-2.018 1.792-3.188 6.561-3.641 11.661-3.37 11.715-3.366.434.028.805-.3.827-.73a.8.8 0 0 0-.742-.837z",
  fill: "url(#bug_svg__paint7_linear)"
});

var _ref17 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "bug_svg__paint0_linear",
  x1: -6.322,
  y1: -21.717,
  x2: 22.618,
  y2: 39.817,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#EAEFFB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), React.createElement("linearGradient", {
  id: "bug_svg__paint1_linear",
  x1: -6.322,
  y1: -21.717,
  x2: 22.618,
  y2: 39.817,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#EAEFFB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), React.createElement("linearGradient", {
  id: "bug_svg__paint2_linear",
  x1: -6.322,
  y1: -21.717,
  x2: 22.618,
  y2: 39.817,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#EAEFFB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), React.createElement("linearGradient", {
  id: "bug_svg__paint3_linear",
  x1: -6.322,
  y1: -21.717,
  x2: 22.618,
  y2: 39.817,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#EAEFFB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), React.createElement("linearGradient", {
  id: "bug_svg__paint4_linear",
  x1: -6.322,
  y1: -21.717,
  x2: 22.618,
  y2: 39.817,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#EAEFFB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), React.createElement("linearGradient", {
  id: "bug_svg__paint5_linear",
  x1: -6.322,
  y1: -21.717,
  x2: 22.618,
  y2: 39.817,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#EAEFFB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), React.createElement("linearGradient", {
  id: "bug_svg__paint6_linear",
  x1: -6.322,
  y1: -21.717,
  x2: 22.618,
  y2: 39.817,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#EAEFFB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), React.createElement("linearGradient", {
  id: "bug_svg__paint7_linear",
  x1: -6.322,
  y1: -21.717,
  x2: 22.618,
  y2: 39.817,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#EAEFFB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})));

const SvgBug = props => React.createElement("svg", _extends({
  viewBox: "0 0 46 50",
  fill: "none"
}, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);

export default SvgBug;